import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ProductsContainerComponent } from './container/products-container/products-container.component';
import { LocalizeRouterService, ShellLocalize } from '@app/i18n';
import { ProductComponent } from './container/product/product.component';
import { CategoryComponent } from './container/category/category.component';
import { ProductsComponent } from './container/products/products.component';

export const PRODUCTS_ROUTES: Routes = ShellLocalize.childRoutes([
    {
        path: '',
        component: ProductsContainerComponent,
        children: [
            {
                path: '',
                redirectTo: 'page/1',
                pathMatch: 'full',
            },
            {
                path: 'page/:pageNumber',
                component: ProductsComponent,
                data: {
                    title: 'products',
                },
            },
            {
                path: 'all/:productId',
                component: ProductComponent,
            },
            {
                path: 'category/:slug',
                pathMatch: 'full',
                redirectTo: (route) => {
                    const localizeRouterService = inject(LocalizeRouterService);
                    const translatedPath = localizeRouterService.translateRoute(['/products', 'category', route.params['slug'], 'page', '1']);
                    return translatedPath.join('/');
                },
            },
            {
                path: 'category/:slug/page/:pageNumber',
                component: CategoryComponent,
            },
            {
                path: 'category/:slug/:productId',
                component: ProductComponent,
            },
        ],
    },
]);
